<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="text-right">
          <button @click="getTaksks" class="btn btn-outline-success btn-xs" type="button">Обновить задачи</button>
        </div>
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading">
          <template v-if="!tasks || !tasks.length">
            <div class="alert alert-info">
              <p>На данный момент нет активных задач на создание</p>
            </div>
          </template>
          <template v-else>
            <div>
              <table class="table table-sm table-hover">
                <thead>
                <tr>
                  <th></th>
                  <th>ID</th>
                  <th>Препарат</th>
                  <th>Проекты</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(task, i) in tasks" :key="task.id">
                  <td>{{ i + 1 }} <span class="text-muted">({{ task.id }})</span></td>
                  <td>{{ task.object_id }}</td>
                  <td><span :class="`priority priority-${task.drug && task.drug.priority || 0}`"/>
                    {{ task.drug && task.drug.title }}
                  </td>
                  <td>
                    <strong>
                      <span v-for="(projectId, i) in task.task_data.selected_projects">{{
                          i !== 0 ? ', ' : ''
                        }}{{ $AllProjects[projectId].title }}</span>
                    </strong>
                  </td>
                  <td>
                    <button @click="openTask(task.id)" class="btn btn-outline-success">Создать</button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import store from '@/store'

export default {
  data() {
    return {
      loading: false,
      tasks: null,
    }
  },
  computed: {
    $AllProjects() {
      const sites = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return sites;
    },
  },
  created() {
    this.getTaksks();
  },
  methods: {
    openTask(taskId) {
      store.dispatch('modals/setSideData', {type: 'createDrugTask', taskId})
    },
    async getTaksks() {
      this.loading = true;
      const {data} = await api.index('/tasks');
      if (data.success) {
        this.tasks = data.records;
      } else {
        toastr['warning'](data.message || 'Ошибка!');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.table td {
  padding: 3px 5px;
}
</style>
